const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// =========================================================
// PRODUCTS / ORDERS BY LOCATION
// Default = last 6 months
// all = true => all products
// =========================================================

export const GetItemsByLocation = async (token, noEmplacement, all = false) => {
  try {
    const response = await fetch(
      `${API}/Complaint/GetItemsByLocation/${noEmplacement}?all=${all}`,
      {
        method: "GET",
        headers: headers(token),
      },
    );

    if (!response.ok) {
      throw new Error(`Unable to retrieve products (${response.status})`);
    }

    return await response.json();
  } catch (error) {
    console.error("GetItemsByLocation failed:", error);

    throw error;
  }
};

// =========================================================
// ITEMS OF SELECTED PRODUCT / ORDER
// =========================================================

export const GetItemsByOrder = async (token, orderId) => {
  try {
    const response = await fetch(
      `${API}/Complaint/GetItemsByOrder/${orderId}`,
      {
        method: "GET",
        headers: headers(token),
      },
    );

    if (!response.ok) {
      throw new Error(`Unable to retrieve items (${response.status})`);
    }

    return await response.json();
  } catch (error) {
    console.error("GetItemsByOrder failed:", error);

    throw error;
  }
};

// =========================================================
// CONTACT
// =========================================================

export const GetInfosContact = async (token, userName) => {
  try {
    const response = await fetch(
      `${API}/Complaint/GetInfosContact/${userName}`,
      {
        method: "GET",
        headers: headers(token),
      },
    );

    if (!response.ok) {
      throw new Error(`Unable to retrieve contact (${response.status})`);
    }

    return await response.json();
  } catch (error) {
    console.error("GetInfosContact failed:", error);

    throw error;
  }
};

// =========================================================
// SUBMIT COMPLAINT
// =========================================================

export const SubmitComplaint = async (token, complaintData) => {
  try {
    const formData = new FormData();

    // =====================================================
    // COMMUN TRANSPORT + PRODUCT
    // =====================================================

    formData.append("IdRestaurant", complaintData.IdRestaurant ?? "");

    formData.append("NomResponsable", complaintData.NomResponsable || "");

    formData.append("PhoneNumber", complaintData.PhoneNumber || "");

    formData.append("TypePlainte", complaintData.TypePlainte || "");

    // =====================================================
    // PRODUCT
    // =====================================================

    if (complaintData.TypePlainte?.toLowerCase() === "product") {
      if (
        complaintData.IdOrder !== null &&
        complaintData.IdOrder !== undefined
      ) {
        formData.append("IdOrder", complaintData.IdOrder);
      }

      formData.append("Item", complaintData.Item || "");

      formData.append("CustomItem", complaintData.CustomItem || "");

      formData.append("BatchNumber", complaintData.BatchNumber || "");

      formData.append("ProductionDate", complaintData.ProductionDate || "");

      formData.append("ExpirationDate", complaintData.ExpirationDate || "");

      formData.append("Quantity", complaintData.Quantity ?? 0);

      formData.append("TypeQuantity", complaintData.TypeQuantity || "");

      formData.append("TextComplaint", complaintData.TextComplaint || "");

      formData.append(
        "BatchNumberDisabled",
        complaintData.BatchNumberDisabled ?? false,
      );

      formData.append(
        "ProductionDateDisabled",
        complaintData.ProductionDateDisabled ?? false,
      );

      formData.append(
        "ExpirationDateDisabled",
        complaintData.ExpirationDateDisabled ?? false,
      );
    }

    // =====================================================
    // TRANSPORT
    // =====================================================

    if (complaintData.TypePlainte?.toLowerCase() === "transport") {
      formData.append("Item", complaintData.Item || "0");

      formData.append("TextComplaint", complaintData.TextComplaint || "");
    }

    // =====================================================
    // PHOTOS
    // Transport + Product
    // =====================================================

    if (complaintData.Files?.length > 0) {
      complaintData.Files.forEach((file) => {
        formData.append("Files", file);
      });
    }

    // =====================================================
    // REQUEST
    // =====================================================

    const response = await fetch(`${API}/Complaint/SubmitComplaint`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    // =====================================================
    // ERROR
    // =====================================================

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);

      console.error("BACKEND ERROR:", errorData);

      throw new Error(
        errorData?.messageFr ||
          errorData?.messageEn ||
          `Unable to submit complaint (${response.status})`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("SubmitComplaint failed:", error);

    throw error;
  }
};

// =========================================================
// DELETE COMPLAINT
// =========================================================

export const DeleteComplaintById = async (token, complaintId, lang = "FR") => {
  try {
    const response = await fetch(
      `${API}/Complaint/DeleteComplaintById/${complaintId}`,
      {
        method: "DELETE",
        headers: headers(token),
      },
    );

    const responseData = await response.json().catch(() => null);

    // =====================================================
    // ERROR
    // =====================================================

    if (!response.ok) {
      const message =
        lang === "EN"
          ? responseData?.messageEn ||
            responseData?.messageFr ||
            `Unable to delete complaint (${response.status})`
          : responseData?.messageFr ||
            responseData?.messageEn ||
            `Impossible de supprimer la plainte (${response.status})`;

      throw new Error(message);
    }

    // =====================================================
    // SUCCESS
    // =====================================================

    return responseData;
  } catch (error) {
    console.error("DeleteComplaintById failed:", error);

    throw error;
  }
};

// =========================================================
// DELETE COMPLAINT IMAGE
// =========================================================

export const DeleteComplaintImageById = async (token, imageId, lang = "FR") => {
  try {
    const response = await fetch(
      `${API}/Complaint/DeleteComplaintImageById/${imageId}`,
      {
        method: "DELETE",
        headers: headers(token),
      },
    );

    const responseData = await response.json().catch(() => null);

    // =====================================================
    // ERROR
    // =====================================================

    if (!response.ok) {
      const message =
        lang === "EN"
          ? responseData?.messageEn ||
            responseData?.messageFr ||
            `Unable to delete image (${response.status})`
          : responseData?.messageFr ||
            responseData?.messageEn ||
            `Impossible de supprimer l'image (${response.status})`;

      throw new Error(message);
    }

    // =====================================================
    // SUCCESS
    // =====================================================

    return responseData;
  } catch (error) {
    console.error("DeleteComplaintImageById failed:", error);

    throw error;
  }
};
